const LOAD_DATA_MASTER_LANGUAGE       = 'LOAD_DATA_MASTER_LANGUAGE'
const LOAD_DATA_MASTER_LANGUAGE_SUCCESS = 'LOAD_DATA_MASTER_LANGUAGE_SUCCESS'
const LOAD_DATA_MASTER_LANGUAGE_FAILED  = 'LOAD_DATA_MASTER_LANGUAGE_FAILED'
const UNMOUNT_DATA_MASTER_LANGUAGE     = 'UNMOUNT_DATA_MASTER_LANGUAGE'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_LANGUAGE:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_LANGUAGE_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_LANGUAGE_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_LANGUAGE:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default languageReducer